var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { Setting } from '@/models/Setting';
import ErrorHandler from '@/support/ErrorHandler';
let ReleaseRosterDialog = class ReleaseRosterDialog extends Vue {
    constructor() {
        super(...arguments);
        this.filteredSettings = {
            soft_lock_date: '',
            hard_lock_date: '',
            visibility_date_teachers: '',
            visibility_date_students: '',
        };
        this.dateModals = {
            soft_lock: false,
            hard_lock: false,
            visibility_teacher: false,
            visibility_student: false,
        };
        this.isLoading = false;
    }
    mounted() {
        this.collectSettings();
    }
    close() {
        this.$emit('input', false);
    }
    collectSettings() {
        Object.keys(this.filteredSettings).forEach((key) => {
            const setting = this.$store.state.settings.find((setting) => {
                return setting.key === key;
            });
            if (setting) {
                this.filteredSettings[key] = setting.value;
            }
        });
    }
    updateSettings() {
        this.$emit('releasingRoster');
        const payload = Object.keys(this.filteredSettings).map((key) => {
            return {
                key,
                value: this.filteredSettings[key],
            };
        });
        new Setting()
            .update(payload)
            .then((settings) => {
            this.$store.dispatch('loadedSettings', settings);
            this.collectSettings();
            this.isLoading = false;
            this.$emit('rosterReleased');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
};
ReleaseRosterDialog = __decorate([
    Component({
        components: {
            DataTable,
        },
    })
], ReleaseRosterDialog);
export default ReleaseRosterDialog;
